function currentStatusTone(status) {
  return status === "closed" ? "stale" : "ready";
}

function ownerLabel(conversation) {
  return conversation && conversation.assigned_user_id ? "Assigned" : "Unassigned";
}

function timelineTone(item) {
  if (!item) {
    return "muted";
  }
  if (String(item.event_type || "").includes("disposition")) {
    return "stale";
  }
  if (String(item.event_type || "").includes("message")) {
    return "ready";
  }
  return "muted";
}

export function buildContactRecordWorkspace(options = {}) {
  const settings = Object.assign(
    {
      conversation: null,
      relatedConversations: [],
      timelineEvents: [],
      recentMessages: [],
    },
    options
  );
  const conversation = settings.conversation || {};
  const related = Array.isArray(settings.relatedConversations) ? settings.relatedConversations : [];
  const timeline = Array.isArray(settings.timelineEvents) ? settings.timelineEvents : [];
  const messages = Array.isArray(settings.recentMessages) ? settings.recentMessages : [];
  const latestMessage = messages.length ? messages[messages.length - 1] : null;

  return {
    factRows: [
      {
        label: "Contact name",
        value: conversation.contact_name || "Unknown contact",
        tone: "ready",
        meta: conversation.contact_id || "Contact id unavailable",
      },
      {
        label: "Primary phone",
        value: conversation.phone_e164 || "Phone unavailable",
        tone: "muted",
        meta: conversation.phone_id || "Phone id unavailable",
      },
      {
        label: "Conversation state",
        value: conversation.status || "open",
        tone: currentStatusTone(conversation.status || "open"),
        meta: ownerLabel(conversation),
      },
      {
        label: "Latest message",
        value: latestMessage ? latestMessage.direction || "message" : "No thread messages",
        tone: latestMessage ? "ready" : "muted",
        meta: latestMessage ? latestMessage.body || "Body unavailable" : "No message returned for this record.",
      },
    ],
    relatedRows: related.length
      ? related.slice(0, 4).map((item) => ({
          label: item.id === conversation.id ? "Current conversation" : item.contact_name || "Conversation",
          value: item.aging_bucket || item.status || "open",
          tone: item.id === conversation.id ? "ready" : currentStatusTone(item.status || "open"),
          meta: `${ownerLabel(item)} | ${item.last_message_at || item.created_at || "No activity timestamp"}`,
        }))
      : [
          {
            label: "Related conversations",
            value: "No additional history",
            tone: "muted",
            meta: "This contact has no other conversation records in the CRM yet.",
          },
        ],
    timelineRows: timeline.length
      ? timeline.slice(0, 5).map((item) => ({
          label: item.summary || item.event_type || "Timeline event",
          value: item.event_type || "event",
          tone: timelineTone(item),
          meta: item.occurred_at || "Timestamp unavailable",
        }))
      : [
          {
            label: "Timeline history",
            value: "No contact timeline events",
            tone: "muted",
            meta: "The CRM has not recorded a contact-level timeline entry for this record yet.",
          },
        ],
  };
}
